import { TextStyle as TextStyleExtension } from '@tiptap/extension-text-style';

export const TextStyle = TextStyleExtension.extend({
  parseHTML() {
    const parentConfig = this.parent?.() ?? [];
    return [
      ...parentConfig,
      {
        style: 'color',
        getAttrs: (value) => {
          return { color: value };
        },
      },
      {
        tag: 'font',
        getAttrs: (element) => {
          const color = (element as HTMLElement).getAttribute('color');
          return color ? { color } : false;
        },
      },
    ];
  },
});
